import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Home, LayoutDashboard } from 'lucide-react';
import styles from './NotFound.module.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.page}>
            <div className={styles.card}>
                <p className={styles.badge}>404 &bull; Page not found</p>
                <h1 className={styles.title}>
                    We couldn&apos;t find that <span className={styles.accent}>page</span>
                </h1>
                <p className={styles.subtitle}>
                    The link you opened doesn&apos;t match any LivePulse page. It may be outdated or mistyped.
                </p>
                <div className={styles.actions}>
                    <button
                        type="button"
                        className={`btn-pill-primary ${styles.primaryBtn}`}
                        onClick={() => navigate('/')}
                    >
                        <Home size={16} aria-hidden />
                        Go to home
                    </button>
                    <Link to="/dashboard" className={styles.secondaryLink}>
                        <LayoutDashboard size={16} aria-hidden />
                        Go to dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;

